import React from 'react';

/** Keeps the browser tab title in step with the route. */
export function useDocumentTitle(title: string, description?: string): void {
  React.useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute('content') ?? null;
    if (description && meta) meta.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
      if (description && meta && previousDescription) {
        meta.setAttribute('content', previousDescription);
      }
    };
  }, [title, description]);
}
